import {isNil, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {getSafely} from 'shared/web';

/**
 * Backend `envkvRequiredReasonCodes` that explain why a passenger car needs EnVKV data, each
 * mapped to the sentence that tells the user why. A car counts as new up to 1,000 km or within
 * eight months of its first registration; a missing mileage or first registration makes the
 * backend treat the car as new until the value is filled in.
 */
const REQUIREMENT_REASON_LABEL_KEYS: Readonly<Record<string, string>> = {
  MILEAGE_WITHIN_LIMIT: 'page.pkwEnvkv.requirementReasons.newVehicle',
  REGISTRATION_WITHIN_EIGHT_MONTHS: 'page.pkwEnvkv.requirementReasons.newVehicle',
  MISSING_MILEAGE: 'page.pkwEnvkv.requirementReasons.missingMileage',
  MISSING_FIRST_REGISTRATION: 'page.pkwEnvkv.requirementReasons.missingFirstRegistration',
};

export function getPkwEnvkvRequirementReasonLabel(reasonCodes: string[]): string | null {
  const labelKey = reasonCodes
    .map((code) => getSafely(REQUIREMENT_REASON_LABEL_KEYS, code))
    .find(isNotNil);

  return isNil(labelKey) ? null : i18n.t(labelKey);
}
